document.addEventListener("DOMContentLoaded", function () {
    let minPriceInput = document.getElementById("filter-price-Price-GTE");
    let maxPriceInput = document.getElementById("filter-price-Price-LTE");
    let minPriceInputMobile = document.getElementById("filter-price-Price-GTE-mob");
    let maxPriceInputMobile = document.getElementById("filter-price-Price-LTE-mob");
    let ratingsForm = document.getElementById("ratings-form");
    let ratingsFormMobile = document.getElementById("ratings-form-mob");
    let debounceTimer;

    function updateURL() {
        clearTimeout(debounceTimer);

        const targetId = this.id;
        const selectedRatings = document.querySelectorAll('input[name="filter-p-m-filter-rating"]:checked');
        const selectedRatingsMobile = document.querySelectorAll('input[name="filter-p-m-filter-rating-mob"]:checked');

        debounceTimer = setTimeout(function () {
          let minPrice;
          let maxPrice;
          let ratingsList;

          if (targetId == 'filter-price-Price-GTE' || targetId == 'filter-price-Price-LTE' || targetId == 'ratings-form') {
            minPrice = minPriceInput ? parseInt(minPriceInput.value.trim()) : "";
            maxPrice = maxPriceInput ? parseInt(maxPriceInput.value.trim()) : "";
            ratingsList = Array.from(selectedRatings).map(checkbox => checkbox.value); 
          } else {
            minPrice = minPriceInput ? parseInt(minPriceInputMobile.value.trim()) : "";
            maxPrice = maxPriceInput ? parseInt(maxPriceInputMobile.value.trim()) : "";  
            ratingsList = Array.from(selectedRatingsMobile).map(checkbox => checkbox.value); 
          }

          let url = new URL(window.location.href);

          url.searchParams.delete("page");

          if (minPrice && maxPrice && maxPrice < minPrice) {
            url.searchParams.set("filter.v.price.gte", maxPrice);
            url.searchParams.set("filter.v.price.lte", minPrice);
          }
          else {
            if (minPrice) {
              url.searchParams.set("filter.v.price.gte", minPrice);
            } else {
              url.searchParams.delete("filter.v.price.gte");
            }

            if (maxPrice) {
              url.searchParams.set("filter.v.price.lte", maxPrice);
            } else {
              url.searchParams.delete("filter.v.price.lte");
            }
          }

          if (ratingsList && ratingsList.length > 0) {
            url.searchParams.set("filter.p.m.filter.rating", ratingsList.join(","));
            url = decodeURIComponent(url.toString());
          } else {
            url.searchParams.delete("filter.p.m.filter.rating");
          }

          window.location.href = url.toString();
        }, 2000); // Wait 2 seconds after last input change
    }

    if (minPriceInput) minPriceInput.addEventListener("input", updateURL);
    if (maxPriceInput) maxPriceInput.addEventListener("input", updateURL);
    if (ratingsForm) ratingsForm.addEventListener("change", updateURL);
    if (minPriceInputMobile) minPriceInputMobile.addEventListener("input", updateURL);
    if (maxPriceInputMobile) maxPriceInputMobile.addEventListener("input", updateURL);
    if (ratingsFormMobile) ratingsFormMobile.addEventListener("change", updateURL);
  });
